import React from "react";
import PropTypes from "prop-types";

import { isAreaPrimary, isCapacityPrimary, withInventory } from "utils/spaces";

import Area from "./Area";
import AreaPrimary from "./AreaPrimary";
import Capacity from "./Capacity";
import CapacityPrimary from "./CapacityPrimary";

const SpaceSizeEdit = ({ field, form, spaceCategory }) => {
  const changeArea = (v) => form.setFieldValue([field.name, "area"].filter(Boolean).join("."), v);
  const changeCapacity = (v) =>
    form.setFieldValue([field.name, "capacity"].filter(Boolean).join("."), v);

  if (isAreaPrimary(spaceCategory)) {
    return (
      <AreaPrimary
        area={field.value.area}
        capacity={field.value.capacity}
        onChangeArea={changeArea}
        onChangeCapacity={changeCapacity}
        spaceCategory={spaceCategory}
      />
    );
  }
  if (isCapacityPrimary(spaceCategory)) {
    return (
      <CapacityPrimary
        area={field.value.area}
        capacity={field.value.capacity}
        onChangeArea={changeArea}
        onChangeCapacity={changeCapacity}
        spaceCategory={spaceCategory}
      />
    );
  }
  if (withInventory(spaceCategory)) {
    return <Capacity capacity={field.value.capacity} onChange={changeCapacity} />;
  }

  return <Area area={field.value.area} onChange={changeArea} />;
};

SpaceSizeEdit.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.shape({
      area: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        unit: PropTypes.string,
      }).isRequired,
      capacity: PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        unit: PropTypes.string,
      }).isRequired,
    }),
  }),
  form: PropTypes.shape({
    setFieldValue: PropTypes.func,
  }),
  spaceCategory: PropTypes.string,
};

SpaceSizeEdit.defaultProps = {
  spaceCategory: "other",
};

export default SpaceSizeEdit;
